import { connect } from "react-redux";

import AttributeReady from "components/answer/AttributeReady";

import {
  setHeaderInfo,
  startEffect,
  finishEffect
} from "redux/modules/answer/answerHeader";
import { set as setSurveyLocale } from "redux/modules/answer/attributeReady";
import { set as setSurveyAttrs } from "redux/modules/answer/answerAttribute";
import { set as setQuestions } from "redux/modules/answer/answerQuestion";
import { setFreeCommentDescriptions } from "redux/modules/answer/answerOther";
import { openErrorDialog } from "redux/modules/errorDialog";
import { setAuthErrorType } from "redux/modules/answer/answerLogin";

import history from "utils/history";
import storage from "utils/storage";
import { answerLoginURL } from "utils/formatter";
import api from "api";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  attributeReady: state.attributeReady,
  answerResult: state.answerResult
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  fetchAttributeReady: (answerToken, localeId) => {
    const params = {
      urlToken: storage.getUrlToken(),
      id: storage.getSurveyId(),
      localeId,
      answerToken
    };

    api
      .get("attr_ready", params)
      .then(res => {
        if (res.invalidStatusError) {
          dispatch(setAuthErrorType("canNotAnswer"));
          history.push(answerLoginURL(), ownProps);
        } else {
          dispatch(setHeaderInfo(res.headerInfo));
          dispatch(setSurveyLocale(res.surveyLocale));
          dispatch(setSurveyAttrs(res.surveyAttrs));
          dispatch(setQuestions(res.basicQuestions, res.additions));
          dispatch(setFreeCommentDescriptions(res.freeCommentDescriptions));
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleNext: () => {
    dispatch(startEffect());

    setTimeout(() => {
      history.push("/answer_attribute", ownProps);

      dispatch(finishEffect());
    }, 300);
  },
  handleBack: () => {
    dispatch(startEffect());

    setTimeout(() => {
      ownProps.history.goBack();

      dispatch(finishEffect());
    }, 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AttributeReady);



// WEBPACK FOOTER //
// ./src/containers/answer/AttributeReadyContainer.js